module.exports = __webpack_public_path__ + "static/media/play-black.30f75613.svg";